<template>
<div class="group">
  <el-card class="box-card" shadow="never">
    <el-button icon="el-icon-back" v-if="active != -1" style="float:left;margin-left:10px;" type="primary" @click="setActive(-1)">返回</el-button>
    <div v-if="active != -1" style="width:80%;margin:0px auto;font-size:14px;">
      <el-steps :active="active" align-center process-status="finish" finish-status="wait">
        <el-step title="导入项目" @click.native="setActive(0)"></el-step>
        <el-step title="指标配置" @click.native="setActive(1)"></el-step>
        <el-step title="模块排序" @click.native="setActive(2)"></el-step>
        <el-step title="算法配置" @click.native="setActive(3)"></el-step>
        <el-step title="分组" @click.native="setActive(4)"></el-step>
      </el-steps>
    </div>
    <div class="wrap-page">
      <div v-show="active == -1">
        <el-form ref="form" :inline="true" :model="form">
          <el-form-item>
            <el-button icon="el-icon-plus" type="primary" @click="addRow">追加一行</el-button>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchKey" clearable placeholder="请输入关键字" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchGroupInfoByPageV2">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" border style="width: 100%;margin-top: 10px;" height="64vh">
          <el-table-column prop="id" label="组织编号" width="120">
            <template slot-scope="{ row }">
              {{ row.id }}
            </template>
          </el-table-column>
          <el-table-column prop="groupName" label="组织名称">
            <template slot-scope="{ row }">
              <template v-if="row.edit">
                <el-input v-model="row.groupName" class="edit-input" size="small" />
              </template>
              <span v-else>{{ row.groupName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ownerName" label="组织主题">
            <template slot-scope="{ row }">
              <template v-if="row.edit">
                <el-input v-model="row.ownerName" class="edit-input" size="small" />
              </template>
              <span v-else>{{ row.ownerName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ownerName" label="平台名称">
            <template slot-scope="{ row }">
              <template v-if="row.edit">
                <el-input v-model="row.showName" class="edit-input" size="small" />
              </template>
              <span v-else>{{ row.showName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="imageUrl" label="组织图片">
            <template slot-scope="{ row }">
              <template v-if="row.edit">
                <input type="file" accept="image/png,image/gif,image/jpeg" name="file" @change="getImg($event)" />
              </template>
              <img v-else :src="row.imageUrl" style="width: 80px;height: 30px;" />
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="400">
            <template slot-scope="{ row }">
              <span v-if="row.edit">
                <el-button type="success" size="small" icon="el-icon-circle-check-outline" @click="confirmEdit(row)">确定</el-button>
                <el-button class="cancel-btn" size="small" icon="el-icon-refresh" type="warning" @click="cancelEdit(row)">取消</el-button>
              </span>
              <span v-else>
                <el-button class="btn" type="text" size="small" @click="row.edit = !row.edit">修改</el-button>
                <el-button class="btn" type="text" size="small" @click="toImportProject(row)">导入项目</el-button>
                <el-button class="btn" type="text" size="small" @click="toFirstAllocation(row)">指标配置</el-button>
                <el-button class="btn" type="text" size="small" @click="toUpdateOrder(row)">模块排序</el-button>
                <el-button class="btn" type="text" size="small" @click="toAlgorithm(row)">算法配置</el-button>
                <el-button class="btn" type="text" size="small" @click="toGrouping(row)">分组</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="pageList" :page-size="pages.size" layout="total, sizes, prev, pager, next, jumper" :total="total" style="text-align: center;margin-top:20px;"></el-pagination>
      </div>
      <ImportProject v-if="active == 0" :groupId="groupId"></ImportProject>
      <FirstAllocation v-if="active == 1" :groupId="groupId"></FirstAllocation>
      <UpdateOrder v-if="active == 2" :groupId="groupId" :groupName="groupName"></UpdateOrder>
      <Algorithm v-if="active == 3" :currentEntityId="groupId" :currentEntityName="groupName"></Algorithm>
      <GroupConfig v-if="active == 4" :groupId="groupId"></GroupConfig>
    </div>
  </el-card>
</div>
</template>

<script>
import GROUPAPI from '@/api/group';
import ImportProject from './importproject';
import Algorithm from './algorithm';
import FirstAllocation from './firstallocation';
import UpdateOrder from './updateorder';
import GroupConfig from './groupConfig';
import getObsClient from '@/utils/getObsClient';
export default {
  components: {
    ImportProject,
    Algorithm,
    FirstAllocation,
    UpdateOrder,
    GroupConfig
  },
  data() {
    return {
      active: -1,
      groupId: '',
      groupName: '',
      searchKey: '',
      form: {},
      tableData: [],
      pages: {
        page: 1,
        size: 10
      },
      pageList: [10, 20, 30, 50, 100],
      total: 0,
      uploadImg: ''
    };
  },
  methods: {
    setActive(v) {
      this.active = v;
    },
    //上传图片
    getImg(e) {
      let file = e.target.files[0];
      this.uploadUsingFile(file);
    },
    uploadUsingFile(file) {
      let self = this;
      // 照片路径，应该是objectkey=objectkeypath + '/' + 照片名称
      let path = new Date();
      let objectKey = 'image/' + path.getTime();
      let obs = getObsClient();
      obs.putObject({
          Bucket: 'ess-cs',
          Key: objectKey,
          SourceFile: file
        })
        .then(function (result) {
          self.uploadImg = 'https://ess-cs.obs.cn-east-2.myhuaweicloud.com/' + objectKey;
        });
    },
    //获取组织列表
    searchGroupInfoByPageV2() {
      let params = {
        searchKey: this.searchKey,
        pageNumber: this.pages.page,
        pageSize: this.pages.size
      };
      GROUPAPI.searchGroupInfoByPageV2(params).then(res => {
        if (res.data.data.records instanceof Array) {
          let data = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData = data.map(item => {
            item.edit = false;
            return item;
          });
        }
      });
    },
    handleSizeChange(v) {
      this.pages.size = v;
      this.searchGroupInfoByPageV2();
    },
    handleCurrentChange(v) {
      this.pages.page = v;
      this.searchGroupInfoByPageV2();
    },
    //新增一行
    addRow() {
      var obj = {
        id: '',
        groupName: '',
        ownerName: '',
        edit: true
      };
      let has = false;
      this.tableData.forEach(item => {
        if (!item.groupName || !item.ownerName) {
          has = true;
        }
      });
      if (!has) {
        this.tableData.push(obj);
      } else {
        this.$message.warning('请完善数据信息！');
      }
    },
    //添加数据
    addGroupInfoV2(row) {
      let params = {};
      params.groupName = row.groupName;
      params.ownerName = row.ownerName;
      params.showName = row.showName;
      params.imageUrl = this.uploadImg;
      GROUPAPI.addGroupInfoV2(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchGroupInfoByPageV2();
        }
      });
    },
    //修改一行
    updateGroupInfoV2(row) {
      let params = {};
      params.id = row.id;
      params.groupName = row.groupName;
      params.ownerName = row.ownerName;
      params.showName = row.showName;
      params.imageUrl = this.uploadImg ? this.uploadImg : row.imageUrl;
      GROUPAPI.updateGroupInfoV2(params)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.searchGroupInfoByPageV2();
          }
        })
        .catch(err => {
          this.searchGroupInfoByPageV2();
        });
    },
    //取消编辑
    cancelEdit(row) {
      this.searchGroupInfoByPageV2();
    },
    //确定编辑
    confirmEdit(row) {
      row.edit = false;
      row.originalTitle = row.title;
      if (!row.id) {
        this.addGroupInfoV2(row);
      } else {
        //如果上传的图片为空，则把原始列表的地址累加上
        this.updateGroupInfoV2(row);
      }
    },
    //跳转到导入项目
    toImportProject(row) {
      this.groupId = row.id;
      this.groupName = row.groupName;
      this.active = 0;
    },
    //跳转到指标配置
    toFirstAllocation(row) {
      this.groupId = row.id;
      this.groupName = row.groupName;
      this.active = 1;
    },
    //跳转到模块排序
    toUpdateOrder(row) {
      this.groupId = row.id;
      this.groupName = row.groupName;
      this.active = 2;
    },
    //跳转到模板配置
    toAlgorithm(row) {
      this.groupId = row.id;
      this.groupName = row.groupName;
      this.active = 3;
    },
    //跳转到分组
    toGrouping(row) {
      this.groupId = row.id;
      this.groupName = row.groupName;
      this.active = 4;
    }
  },
  created() {
    this.active = -1;
    this.searchGroupInfoByPageV2();
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  .btn {
    padding: 0px;
    font-size: 12px !important;

    &span {
      font-size: 12px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/group/index.vue